module.exports = __webpack_public_path__ + "0-es2015.1fc360c3e3bf6c2b791a.worker.js"